import { TouchableOpacity, Text, View, StyleSheet, StyleProp, ViewStyle } from 'react-native';
import LinearGradient from 'react-native-linear-gradient';

import React from 'react';

type THexagonIconButtonProps = {
  onPress: () => void;
  hexagonIcon?: React.ReactNode;
  text?: string;
  iconRight?: React.ReactNode;
  mainContainerStyle?: StyleProp<ViewStyle>;
  textContainerStyle?: StyleProp<ViewStyle>;
};

export default function HexagonIconButton(props: THexagonIconButtonProps) {
  const { onPress, hexagonIcon, text, iconRight, mainContainerStyle, textContainerStyle } = props;
  return (
    <TouchableOpacity style={[styles.mainContainer, mainContainerStyle]} onPress={onPress}>
      <LinearGradient
        style={[styles.textContainer, textContainerStyle]}
        colors={['#FFCF53', '#FF9900']}
      >
        <Text numberOfLines={1} maxFontSizeMultiplier={1} style={styles.text}>
          {text}
        </Text>
        {iconRight}
      </LinearGradient>

      <View style={styles.hexagonContainer}>{hexagonIcon}</View>
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  mainContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginRight: 16,
  },
  textContainer: {
    borderRadius: 12,
    width: 140,
    height: 51,
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    position: 'relative',
    paddingLeft: 50,
  },
  text: {
    fontFamily: 'Secular One',
    marginTop: 4,
    fontSize: 16,
    color: '#000000',
    fontWeight: '400',
  },
  hexagonContainer: {
    position: 'absolute',
    left: -10,
  },
});
